import React from "react";
import "./styles.less";

import Helmet from "react-helmet";
import { useTranslation } from "react-i18next";

import { Footer } from "../../components/FooterV2";
import { Header } from "../../components/Header";

import { ZeroCompliance } from "./ZeroCompliance";
import { ZeroOther } from "./ZeroOther";
import { TenantBanner } from "./TenantBanner";
import { TenantPlatform } from "./TenantPlatform";
import { TenantAdvantage3 } from "./TenantAdvantage3";
import { TenantAdvantage2 } from "./TenantAdvantage2";
import { TenantScene } from "./TenantScene";
import { TenantCustomer } from "./TenantCustomer";

export const MultTenantPage = () => {
  const { t } = useTranslation();

  return (
    <div className="zero-trust-page">
      <Helmet>
        <title>
          使用多租户功能，实现多租户的数据隔离与身份管理｜Authing身份云
        </title>
      </Helmet>
      <Header mode="dark" hasNotice />
      <TenantBanner />
      <TenantScene />
      <TenantAdvantage3 />
      <TenantAdvantage2 />
      <TenantPlatform />
      <TenantCustomer />
      <ZeroCompliance />
      <ZeroOther />
      <Footer />
    </div>
  );
};
